module.exports = __webpack_public_path__ + "img/1themeimage.4a3525be.svg";